import { Text } from "@chakra-ui/react";

export const SectionTitle = ({
  title,
  marginTop,
}: {
  title: string;
  marginTop?: boolean;
}) => (
  <Text
    as="h3"
    fontSize={18}
    fontWeight="bold"
    textTransform="uppercase"
    textAlign="center"
    mt={marginTop ? 6 : 2}
  >
    {title}
  </Text>
);
